export default "__VITE_ASSET__BgaE8ZZ9__"